/**
 * Phone breakpoint shared by the stats modals, mirroring the Radix `sm`
 * breakpoint their responsive props use.
 *
 * Keep in sync with the `--phone` custom media query each modal's CSS module
 * declares: media queries can't read a JS constant or a CSS custom property, so
 * this is the one value that has to exist in both places.
 */
export const PHONE_BREAKPOINT_PX = 768
